import Update_Icon from "../images/table/Update_icon.svg";
import Delete_Icon from "../images/table/Delete_icon.svg";
import { getScheduleOccurrenceDetails } from "../utils/scheduleUi";

export const FLEET_SCHEDULE_ROW_ACTIONS = {
  updateSchedule: {
    id: "update",
    label: "Update",
    icon: Update_Icon,
    path: "/schedule",
    permission: { apiPath: "/api/schedule", action: "PUT" },
  },
  deleteSchedule: {
    id: "delete",
    label: "Delete",
    className: "delete",
    icon: Delete_Icon,
    path: "",
    permission: { apiPath: "/api/schedule", action: "DELETE" },
  },
};

function countTripsInNextHour(schedules = []) {
  const now = new Date();
  const nextHour = new Date(now.getTime() + 60 * 60 * 1000);

  return schedules.filter((schedule) => {
    if (schedule.scheduleStatus === "RUNNING") {
      return true;
    }

    const occurrenceStart = getScheduleOccurrenceDetails(schedule).sortValue;

    if (!occurrenceStart) {
      return false;
    }

    const scheduleTime = new Date(occurrenceStart);
    return (
      !Number.isNaN(scheduleTime.getTime()) &&
      scheduleTime >= now &&
      scheduleTime <= nextHour
    );
  }).length;
}

export function computeFleetScheduleMetric(metricKey, scheduleData = []) {
  const schedules = Array.isArray(scheduleData) ? scheduleData : [];

  switch (metricKey) {
    case "totalSchedules":
      return schedules.length;
    case "tripsInNextHour":
      return countTripsInNextHour(schedules);
    default:
      return 0;
  }
}
